import { render } from "./QuizHowTo.vue?vue&type=template&id=1a346884&scoped=true"
import script from "./QuizHowTo.vue?vue&type=script&lang=js"
export * from "./QuizHowTo.vue?vue&type=script&lang=js"

import "./QuizHowTo.vue?vue&type=style&index=0&id=1a346884&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a346884"]])

export default __exports__